import React, { useEffect } from "react";
import {
  Avatar,
  Box,
  Button,
  Grid,
  List,
  ListItem,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import styles from "../../../styles/pages/user/copyrwriterdashboard_dev/copywriter-myaccount.module.scss";

import EditIcon from "../../../ui/Icons/EditIcon";
import { Link, useNavigate } from "react-router-dom";
import userImage from "../../../public/assets/images/user_upload_img.png";
import { useRef } from "react";
import { useState } from "react";
import AlertIcon from "../../../ui/Icons/Alert";
import PerfectScrollbar from "react-perfect-scrollbar";
import UserCopyWriterWrapper from "../../../layout/userwrapper/UserCopyWriterWrapper";
import CopyWriterDashboardWrapper from "../../../layout/wrapper/CopyWriterDashboardWrapper";
import { useMutation, useQueryClient } from "react-query";
import useNotiStack from "../../../hooks/useNotistack";
import { parseCookies } from "nookies";
import useFetch from "../../../hooks/api/useFetch";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { trimStartAndEnd } from "../../../lib/functions/_helpers.lib";
import { ProfileUpdateMutation } from "../../../api/functions/user.api";
import { phoneRegExp } from "../../../config/regExp";
import TabBackIcon from "../../../ui/Icons/TabBackIcon";
import TabSaveIcon from "../../../ui/Icons/TabSaveIcon";
import { CopywritersProfileUpdateMutation } from "../../../api/functions/copywritersDashboard.api";
import {
  getAbsoluteImageURI,
  truncateString,
} from "../../../lib/functions/utils.lib";
import NOprofileImage from "../../../public/assets/images/no-image.svg";

import ChnagePassword from "./Components/ChnagePassword";
import countries from "countries-list";
import { Stack } from "@mui/system";
import { asCleanDays } from "@fullcalendar/core/internal";

// countryData
const countryData = Object.values(countries.countries).map(
  (country) => country.name
);

const SelectItem = [
  {
    name: "Select country",
  },
  {
    name: "Option1",
  },
  {
    name: "Option2",
  },
];
const schema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .required()
    .label("First Name")
    .max(256)
    .transform(trimStartAndEnd),

  last_name: yup
    .string()
    .trim()
    .required()
    .label("Last Name")
    .max(256)
    .transform(trimStartAndEnd),

  address: yup.string().max(32).required("Address fields is required"),
  city: yup.string().max(32).required("City Field is required"),

  zip: yup.string().max(7).required("Zipcode is required"),

  phone: yup
    .string()
    .required()
    .matches(phoneRegExp, "Phone number is not valid")
    .label("Phone number")
    .min(8, "Phone number must be at least 8 characters")
    .max(15, "Phone number must be at most 15 characters"),

  state: yup.string().max(32).required("State field is required"),
});
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function CopyWriterMyAccount() {
  const [value, setValuess] = React.useState(0);

  //   const handleChange = (event, newValue) => {
  //     setValuess(newValue);
  //   };
  const [age, setAge] = React.useState("0");

  //   const handleChange2 = (event) => {
  //     setAge(event.target.value);
  //   };
  const fileInput = useRef(null);
  const handleClick = () => {
    fileInput.current.children[0].children[0].click();
  };

  const [file, setFile] = useState(userImage);

  const fileChange = (e) => {
    console.warn(e.target.files);
    setFile(URL.createObjectURL(e.target.files[0]));
  };
  const handleChanges = (e) => {
    setFile(userImage);
  };

  const cookies = parseCookies();
  const userDetails = JSON?.parse(cookies?.userdetails || "{}");

  // const { userData } = useAppSelector((s) => s.userSlice);
  const userData = JSON.parse(cookies?.userdetails || "{}");

  //   const [value, setValuess] = React.useState(0);
  //   const [age, setAge] = React.useState("");
  const [dis, setDis] = useState(true);
  const [dis1, setDis1] = useState(true);
  const [dis2, setDis2] = useState(true);
  const handleChange = (event, newValue) => {
    setValuess(newValue);
  };
  const {
    data: CopywritersData,
    isLoading: adminIsLoading,
    isSuccess: adminIsSuccess,
    refetch: CopywritersRefetch,
  } = useFetch(["Copywriters"], `user`);

  const {
    handleSubmit,
    control,
    register,
    setValue,
    reset,
    setError,
    formState: { errors },
    formState,
  } = useForm({
    resolver: yupResolver(schema),
    values: {
      name: CopywritersData?.data?.name,
      last_name: CopywritersData?.data?.last_name,
      address: CopywritersData?.data?.address,
      city: CopywritersData?.data?.city,
      zip: CopywritersData?.data?.zip_code,
      state: CopywritersData?.data?.state,
      phone: CopywritersData?.data?.phone,
      avatar: CopywritersData?.data?.avatar,
      country: CopywritersData?.data?.country,
    },
  });

  // useEffect(() => {
  //   setValue("name", CopywritersData?.data?.name);
  //   setValue("last_name", CopywritersData?.data?.last_name);
  //   setValue("address", CopywritersData?.data?.address);
  //   setValue("city", CopywritersData?.data?.city);
  //   setValue("zip", CopywritersData?.data?.zip_code);
  //   setValue("phone", CopywritersData?.data?.phone);
  //   setValue("avatar", CopywritersData?.data?.avatar);
  //   setValue("country", CopywritersData?.data?.country);
  //   setValue("state", CopywritersData?.data?.state);
  // }, []);

  // const onSubmit = (data: MyAccInput) => console.warn(data);
  const [Country, setCountry] = useState(CopywritersData?.data?.country);

  useEffect(() => {
    setCountry(CopywritersData?.data?.country);
  }, [CopywritersData?.data?.country]);

  const handleChange2 = (event) => {
    setCountry(event.target.value);
  };
  const handleopenD = () => {
    setDis(false);
  };
  const handleopenD1 = () => {
    setDis1(false);
  };
  const handleopenD2 = () => {
    setDis2(false);
  };

  // const handleopenDD = () => {
  //   setDis(true);

  //   setValue("name", CopywritersData?.data?.name);
  //   setValue("last_name", CopywritersData?.data?.last_name);
  // };
  // const handleopenDD1 = () => {
  //   setDis1(true);
  //   setValue("address", CopywritersData?.data?.address);
  //   setValue("city", CopywritersData?.data?.city);
  //   setValue("zip", CopywritersData?.data?.zip_code);
  //   setValue("country", CopywritersData?.data?.country);
  //   setValue("state", CopywritersData?.data?.state);
  // };
  // const handleopenDD2 = () => {
  //   setDis2(true);
  //   setValue("phone", CopywritersData?.data?.phone);
  // };

  const setFormValues = (data) => {
    setValue("name", data.name);
    setValue("last_name", data.last_name);
    setValue("address", data.address);
    setValue("city", data.city);
    setValue("zip", data.zip_code);
    setValue("country", data.country);
    setValue("state", data.state);
    setValue("phone", data.phone);
  };

  const handleopenDD = () => {
    setDis(true);
    setFormValues(CopywritersData?.data || {});
    setError("name", "");
    setError("last_name", "");
  };

  const handleopenDD1 = () => {
    setDis1(true);
    setFormValues(CopywritersData?.data || {});
    setError("city", "");
    setError("state", "");
    setError("zip", "");
    setError("address", "");
  };

  const handleopenDD2 = () => {
    setDis2(true);
    setValue("phone", CopywritersData?.data?.phone);
    setError("phone", "");
  };

  const { mutateAsync: ProfileUpdateMutationAA } = useMutation({
    mutationFn: CopywritersProfileUpdateMutation,
  });
  const { toastSuccess, toastError } = useNotiStack();
  const queryClient = useQueryClient();
  7;
  const [profileImage, setProfileImage] = useState(null);
  const [profileimg, setprofileimg] = useState(CopywritersData?.data?.avatar);
  const [defaultImg, setDefaultImg] = useState(CopywritersData?.data?.avatar);
  const [imageCheck, setImageCheck] = useState(false);
  const [inputKey, setInputKey] = useState(0);
  const removeprofileImage = () => {
    setProfileImage(null);
    setprofileimg(null);
    setImageCheck(true);
    setInputKey((prevKey) => prevKey + 1);
    const formData = new FormData();
    formData.append("remove_avatar", true);
    formData.append("user_id", userData?.id);
    ProfileUpdateMutationAA(formData).then((response) => {
      if (response.message === "User updated successfully") {
        toastSuccess("User updated successfully");
        // router.reload();
        CopywritersRefetch();
        queryClient.invalidateQueries(["Copywriters"]);
      }
    });
  };

  function handleProfileImage1(e) {
    if (
      e.target.files[0]?.type === "image/jpeg" ||
      e.target.files[0]?.type === "image/png" ||
      e.target.files[0]?.type === "image/jpg"
    ) {
      if (e.target.files[0]?.size <= 10000000) {
        setProfileImage(e.target.files[0]);
        setImageCheck(true);
      } else {
        toastError("Please upload image of proper size.");
      }
    } else {
      toastError("Please upload image of proper format.");
    }
  }

  // const onSubmit = (data) => {
  //   const formData = new FormData();
  //   {
  //     profileImage === null ? "" : formData.append("avatar", profileImage);
  //   }

  //   formData.append("name", data?.name);
  //   formData.append("last_name", data?.last_name);
  //   formData.append("user_id", userData?.id);
  //   formData.append("email", userData?.email);
  //   formData.append("address", data?.address);
  //   formData.append("city", data?.city);
  //   formData.append("zip_code", data?.zip);
  //   formData.append("phone", data?.phone);
  //   formData.append("state", data?.state);
  //   formData.append("country", Country);

  //   ProfileUpdateMutationAA(formData).then((response) => {
  //     if (response.message === "User updated successfully") {
  //       setDis(true);
  //       setDis1(true);
  //       setDis2(true);
  //       queryClient.invalidateQueries(["Copywriters"]);
  //       toastSuccess("User updated successfully");
  //       // router.reload();
  //       CopywritersRefetch();
  //     }
  //   });
  // };
  const onSubmit = async (data) => {
    const formData = new FormData();

    if (profileImage !== null) {
      formData.append("avatar", profileImage);
    }

    const formFields = {
      name: data?.name,
      last_name: data?.last_name,
      user_id: userData?.id,
      email: userData?.email,
      address: data?.address,
      city: data?.city,
      zip_code: data?.zip,
      phone: data?.phone,
      state: data?.state,
      country: Country,
    };

    Object.entries(formFields).forEach(([key, value]) => {
      if (value) {
        formData.append(key, value);
      }
    });

    const response = await ProfileUpdateMutationAA(formData);

    if (response.message === "User updated successfully") {
      setDis(true);
      setImageCheck(false);
      setDis1(true);
      setDis2(true);
      queryClient.invalidateQueries(["Copywriters"]);
      toastSuccess("User updated successfully");
      CopywritersRefetch();
    }
    //  else{

    //   alert("sad")
    //   toastError("Old password did not match");
    // }
  };
  const handleCancel = () => {
    // alert("hi")
    setProfileImage(null);
    setImageCheck(false);
    setInputKey((prevKey) => prevKey + 1);
  };

  return (
    <>
      {/* <UserCopyWriterWrapper headerPurchaseBtn={false} footerChatBtn={true}> */}
      <CopyWriterDashboardWrapper chatbtn={true}>
        <Box className={styles.account_settings_wrapper}>
          <Box className={styles.accountsecrp_outer}>
            <Box className={styles.accountsecrp_top}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab label="Personal Details" {...a11yProps(0)} />
                <Tab label="Account Settings" {...a11yProps(1)} />
              </Tabs>
            </Box>

            <Box className={styles.accountsecrp_btms}>
              <PerfectScrollbar>
                <CustomTabPanel value={value} index={0}>
                  <Box className={styles.accountsecrp_btms_inputwrp}>
                    <Box className={styles.heaing_info_label}>
                      <Typography variant="h4">

                        
                        Full name
                        {/* <Link to="" className={styles.wdit_spn}>
                     
                          <EditIcon />{" "}
                        </Link> */}
                        {dis !== false ? (
                          <Button onClick={handleopenD}>
                            <EditIcon />
                          </Button>
                        ) : (
                          <Box className={styles.editSaveBtn}>
                            <Button onClick={handleopenDD}>
                              <TabBackIcon />
                            </Button>
                            <Button onClick={handleSubmit(onSubmit)}>
                              <TabSaveIcon />
                            </Button>
                          </Box>
                        )}
                      </Typography>
                    </Box>

                    <Box className={styles.inputlabel_wrapper_details}>
                      <Grid
                        container
                        rowSpacing={2.75}
                        columnSpacing={{ xs: 1, sm: 2, md: 5.5 }}
                      >
                        <Grid item lg={3.05} xs={12}>
                          <Box className={styles.namedetails_input}>
                            <Typography
                              variant="h6"
                              className={styles.heading_label}
                            >
                              First Name
                            </Typography>
                            <TextField
                              {...register("name")}
                              type="text"
                              disabled={dis}
                              placeholder="First Name"
                            />
                            {errors.name && (
                              <p
                                style={{
                                  color: "red",
                                  textAlign: "left",
                                  fontSize: "15px",
                                }}
                              >
                                {errors.name.message}
                              </p>
                            )}
                          </Box>
                        </Grid>

                        <Grid item lg={3.05} xs={12}>
                          <Box className={styles.namedetails_input}>
                            <Typography
                              variant="h6"
                              className={styles.heading_label}
                            >
                              Last name
                            </Typography>
                            <TextField
                              {...register("last_name")}
                              disabled={dis}
                              placeholder={"Last name"}
                            />
                            {errors.last_name && (
                              <p
                                style={{
                                  color: "red",
                                  textAlign: "left",
                                  fontSize: "15px",
                                }}
                              >
                                {errors.last_name.message}
                              </p>
                            )}
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>

                  <Box className={styles.accountsecrp_btms_inputwrp}>
                    <Box className={styles.heaing_info_label}>
                      <Typography variant="h4">
                        Physical Address
                        {/* <Link to="/" className={styles.wdit_spn}>
                          {" "}
                          <EditIcon />{" "}
                        </Link> */}
                        {dis1 !== false ? (
                          <Button onClick={handleopenD1}>
                            <EditIcon />
                          </Button>
                        ) : (
                          <Box className={styles.editSaveBtn}>
                            <Button onClick={handleopenDD1}>
                              <TabBackIcon />
                            </Button>
                            <Button onClick={handleSubmit(onSubmit)}>
                              <TabSaveIcon />
                            </Button>
                          </Box>
                        )}
                      </Typography>
                    </Box>

                    <Box className={styles.inputlabel_wrapper_details}>
                      <Grid
                        container
                        rowSpacing={2.75}
                        columnSpacing={{ xs: 1, sm: 2, md: 5.5 }}
                      >
                        <Grid item lg={3.63} xs={12}>
                          <Box className={styles.namedetails_input}>
                            <Typography
                              variant="h6"
                              className={styles.heading_label}
                            >
                              Address
                            </Typography>
                            <TextField
                              {...register("address")}
                              type="text"
                              placeholder={""}
                              disabled={dis1}
                            />
                          </Box>
                          {errors.address && (
                            <p
                              style={{
                                color: "red",
                                textAlign: "left",
                                fontSize: "15px",
                              }}
                            >
                              {errors.address.message}
                            </p>
                          )}
                        </Grid>
                        <Grid item lg={2.58} xs={12}>
                          <Box className={styles.namedetails_input}>
                            <Typography
                              variant="h6"
                              className={styles.heading_label}
                            >
                              City
                            </Typography>
                            <TextField
                              {...register("city")}
                              type="text"
                              placeholder={""}
                              disabled={dis1}
                            />
                          </Box>
                          {errors.city && (
                            <p
                              style={{
                                color: "red",
                                textAlign: "left",
                                fontSize: "15px",
                              }}
                            >
                              {errors.city.message}
                            </p>
                          )}
                        </Grid>
                        <Grid item lg={2.58} xs={12}>
                          <Box className={styles.namedetails_input}>
                            <Typography
                              variant="h6"
                              className={styles.heading_label}
                            >
                              State
                            </Typography>
                            <TextField
                              {...register("state")}
                              type="text"
                              placeholder={""}
                              disabled={dis1}
                            />
                          </Box>
                          {errors.state && (
                            <p
                              style={{
                                color: "red",
                                textAlign: "left",
                                fontSize: "15px",
                              }}
                            >
                              {errors.state.message}
                            </p>
                          )}
                        </Grid>
                        <Grid item lg={1.78} xs={12}>
                          <Box className={styles.namedetails_input}>
                            <Typography
                              variant="h6"
                              className={styles.heading_label}
                            >
                              Zip Code
                            </Typography>
                            <TextField
                              {...register("zip")}
                              type="text"
                              placeholder={""}
                              disabled={dis1}
                            />
                          </Box>
                          {errors.zip && (
                            <p
                              style={{
                                color: "red",
                                textAlign: "left",
                                fontSize: "15px",
                              }}
                            >
                              {errors.zip.message}
                            </p>
                          )}
                        </Grid>
                        {/*                    
                        {Country && (
                                <Box
                                  className={styles.namedetails_input_select}
                                >
                                  <Select
                                    onChange={handleChange2}
                                    value={Country}
                                    disabled={dis1}
                                  >
                                    {countryData.map((item, index) => (
                                      <MenuItem key={index} value={item}>
                                        {truncateString(item, 20)}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </Box>
                              )} */}

                        <Grid item lg={3.05} xs={12}>
                          <Box className={styles.namedetails_input}>
                            <Typography
                              variant="h6"
                              className={styles.heading_label}
                            >
                              Country
                            </Typography>
                            {Country && (
                              <Box className={styles.namedetails_input_select}>
                                <Select
                                  onChange={handleChange2}
                                  value={Country}
                                  disabled={dis1}
                                  inputProps={{
                                    "aria-label": "Without label",
                                  }}
                                >
                                  {countryData.map((item, index) => (
                                    <MenuItem key={index} value={item}>
                                      {truncateString(item, 20)}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </Box>
                            )}
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>

                  <Box className={styles.accountsecrp_btms_inputwrp}>
                    <Box className={styles.heaing_info_label}>
                      <Typography variant="h4">
                        Phone Number
                        {/* <Link to="/" className={styles.wdit_spn}>
                          {" "}
                          <EditIcon />{" "}
                        </Link> */}
                        {dis2 !== false ? (
                          <Button onClick={handleopenD2}>
                            <EditIcon />
                          </Button>
                        ) : (
                          <Box className={styles.editSaveBtn}>
                            <Button onClick={handleopenDD2}>
                              <TabBackIcon />
                            </Button>
                            <Button onClick={handleSubmit(onSubmit)}>
                              <TabSaveIcon />
                            </Button>
                          </Box>
                        )}
                      </Typography>
                    </Box>

                    <Box className={styles.inputlabel_wrapper_details}>
                      <Grid
                        container
                        rowSpacing={2.75}
                        columnSpacing={{ xs: 1, sm: 2, md: 5.5 }}
                      >
                        <Grid item lg={3.05} xs={12}>
                          <Box className={styles.namedetails_input}>
                            <TextField
                              type="number"
                              placeholder={""}
                              disabled={dis2}
                              {...register("phone")}
                            />
                            {errors.phone && (
                              <p
                                style={{
                                  color: "red",
                                  textAlign: "left",
                                  fontSize: "15px",
                                }}
                              >
                                {errors.phone.message}
                              </p>
                            )}
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                </CustomTabPanel>

                <CustomTabPanel value={value} index={1}>
                  <Box
                    className={`${styles.accountSettingWrapper} ${styles.accountSettingWrapperPartner}`}
                  >
                    {/* <Box
                      className={`${styles.forProfilePic} ${styles1.forProfilePicPartner}`}
                       >
                      <Stack
                        direction="row"
                        alignItems="center"
                        flexWrap="wrap"
                        className={styles.labelStack}
                      >
                        <Typography variant="caption">
                          Profile Picture
                        </Typography>
                      </Stack>
                      <Stack
                        direction="row"
                        alignItems="center"
                        flexWrap="wrap"
                        className={styles.profileSec}
                      >
                        {profileImage !== null ? (
                          <>
                           

                            <Avatar
                              alt="Profile Image"
                              src={URL.createObjectURL(profileImage)}
                              sx={{ width: 97, height: 97 }}
                            />
                          </>
                        ) : (
                          <>
                            {profileimg === null ? (
                              <Avatar
                                alt="Viral Snare"
                                src={NOprofileImage}
                                sx={{ width: 97, height: 97 }}
                              />
                            ) : (
                              <Avatar
                                alt="Profile Image"
                                src={
                                  CopywritersData?.data?.avatar ===
                                  "users/default.png"
                                    ? NOprofileImage
                                    : getAbsoluteImageURI(
                                        CopywritersData?.data?.avatar
                                      )
                                }
                                sx={{ width: 97, height: 97 }}
                              />
                            )}
                          </>
                        )}

                        <List>
                          <ListItem className={styles.customUploadFile}>
                            <input
                              key={inputKey}
                              type="file"
                              id="upload"
                              hidden
                              onChange={handleProfileImage1}
                              accept="image/*"
                            />
                            {profileImage !== null ? (
                              <>
                                <label
                                  htmlFor="update"
                                  onClick={handleSubmit(onSubmit)}
                                >
                                  update picture
                                </label>
                              </>
                            ) : (
                              <>
                                <label htmlFor="upload">Upload picture</label>
                              </>
                            )}
                          </ListItem>

                          {defaultImg !== "" ? (
                            <ListItem>
                              <Button
                                className={styles.removeBtn}
                                onClick={() => {
                                  removeprofileImage();
                                  handleSubmit(onSubmit);
                                }}
                              >
                                remove it
                              </Button>
                            </ListItem>
                          ) : (
                            <ListItem>
                              <Button
                                className={styles.removeBtn}
                                onClick={() => {
                                  removeprofileImage();
                                  handleSubmit(onSubmit);
                                }}
                              >
                                remove it
                              </Button>
                            </ListItem>
                          )}
                        </List>
                      </Stack>
                    </Box> */}
                    <Box className={styles.profile_pic_upload_sec}>
                      <Typography
                        variant="h4"
                        className={styles.profile_upload_head}
                      >
                        Profile Picture
                      </Typography>
                      <Stack
                        direction="row"
                        alignItems="center"
                        flexWrap="wrap"
                        className={styles.profileSec}
                      >
                        {profileImage !== null ? (
                          <>
                            {/* <img
                           src={URL.createObjectURL(profileImage)}
                            width={100}
                              height={100}
                              alt={""}
                              /> */}

                            <Avatar
                              alt="Profile Image"
                              src={URL.createObjectURL(profileImage)}
                              sx={{ width: 97, height: 97 }}
                            />
                          </>
                        ) : (
                          <>
                            {profileimg === null ? (
                              <Avatar
                                alt="piral Snare"
                                src={NOprofileImage}
                                sx={{ width: 97, height: 97 }}
                              />
                            ) : (
                              <Avatar
                                alt="Profile Image"
                                src={
                                  CopywritersData?.data?.avatar ===
                                  "users/default.png"
                                    ? NOprofileImage
                                    : getAbsoluteImageURI(
                                        CopywritersData?.data?.avatar
                                      )
                                }
                                sx={{ width: 97, height: 97 }}
                              />
                            )}
                          </>
                        )}

                        <List>
                          <ListItem
                            className={styles.customUploadFile}
                            style={{ cursor: "pointer" }}
                          >
                            <input
                              key={inputKey}
                              type="file"
                              id="upload"
                              hidden
                              onChange={handleProfileImage1}
                              accept="image/*"
                            />
                            {profileImage !== null && imageCheck ? (
                              <>
                                <label
                                  style={{ cursor: "pointer" }}
                                  htmlFor="update"
                                  onClick={handleSubmit(onSubmit)}
                                >
                                  save
                                </label>
                              </>
                            ) : (
                              <>
                                {CopywritersData?.data?.avatar ===
                                "users/default.png" ? (
                                  <label
                                    htmlFor="upload"
                                    style={{ cursor: "pointer" }}
                                  >
                                    Upload picture
                                  </label>
                                ) : (
                                  <label
                                    htmlFor="upload"
                                    style={{ cursor: "pointer" }}
                                  >
                                    change picture
                                  </label>
                                )}
                              </>
                            )}
                          </ListItem>
                          {CopywritersData?.data?.avatar !==
                            "users/default.png" || profileImage !== null ? (
                            <>
                              {profileImage !== null && imageCheck ? (
                                <ListItem style={{ cursor: "pointer" }}>
                                  <Button
                                    className={styles.removeBtn}
                                    onClick={handleCancel}
                                  >
                                    cancel
                                  </Button>
                                </ListItem>
                              ) : (
                                <ListItem style={{ cursor: "pointer" }}>
                                  <Button
                                    className={styles.removeBtn}
                                    onClick={() => {
                                      removeprofileImage();
                                      handleSubmit(onSubmit);
                                    }}
                                  >
                                    remove it
                                  </Button>
                                </ListItem>
                              )}
                            </>
                          ) : (
                            ""
                          )}
                        </List>
                      </Stack>
                    </Box>
                  </Box>

                  <Box className={styles.email_details_inputsec}>
                    <Box className={styles.email_details_inputsec_inner}>
                      <Typography
                        variant="h4"
                        className={`${styles.profile_upload_head} ${styles.neww}`}
                      >
                        Email Address
                      </Typography>
                      <Box className={styles.gap_wrapper_emltb}>
                        <Box className={styles.add_user_address}>
                          <Typography variant="body1">
                            Your email address is
                            <Link to={CopywritersData?.data?.email}>
                              {CopywritersData?.data?.email}
                            </Link>
                          </Typography>
                        </Box>
                        <Box className={styles.add_user_emailchn}>
                          <Typography variant="caption">
                            <i>
                              <AlertIcon />
                            </i>
                            Email address cannot be changed.
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                    <ChnagePassword />
                  </Box>
                </CustomTabPanel>
              </PerfectScrollbar>
            </Box>
          </Box>
        </Box>
      </CopyWriterDashboardWrapper>
      {/* </UserCopyWriterWrapper>  */}
    </>
  );
}

export default CopyWriterMyAccount;
